import {api} from '../../../shared';
import {
  BlocksFilter,
  BlockModel,
  BlockWithMetaModel,
  CreateBlockDTO,
  EditBlockDTO,
  EditBlockParams,
  StoriesFilter,
  StoryModel,
  StoryWithMetaModel,
  StoryDetailedModel,
  CreateStoryParams,
  EditStoryParams,
  CreateStoryScreensDTO,
} from '../model';

export const blocksApi = {
  getBlocks: async (params: BlocksFilter = {}): Promise<BlockWithMetaModel> => {
    const {data} = await api.get<BlockWithMetaModel>('/api/content/admin/blocks', {params});
    return data;
  },

  createBlock: async (block: CreateBlockDTO): Promise<BlockModel> => {
    const {data} = await api.post<BlockModel>('/api/content/admin/blocks', block);
    return data;
  },

  getBlockById: async (blockId: string): Promise<BlockModel> => {
    const {data} = await api.get<BlockModel>(`/api/content/admin/blocks/${blockId}`);
    return data;
  },

  updateBlock: async ({blockId, name, title}: EditBlockParams): Promise<BlockModel> => {
    const body: EditBlockDTO = {name, title};
    const {data} = await api.post<BlockModel>(`/api/content/admin/blocks/${blockId}`, body);
    return data;
  },

  deleteBlock: async (blockId: string): Promise<void> => {
    await api.delete(`/api/content/admin/blocks/${blockId}`);
  },

  // API для историй блоков
  getBlockStories: async (params: StoriesFilter): Promise<StoryWithMetaModel> => {
    const {blockId, ...queryParams} = params;
    const {data} = await api.get<StoryWithMetaModel>(`/api/content/admin/blocks/${blockId}/stories`, {
      params: queryParams,
    });
    return data;
  },

  createStory: async ({blockId, title}: CreateStoryParams): Promise<StoryModel> => {
    const {data} = await api.post<StoryModel>(`/api/content/admin/blocks/${blockId}/stories`, {title});
    return data;
  },

  getStoryById: async (blockId: string, storyId: string): Promise<StoryDetailedModel> => {
    const {data} = await api.get<StoryDetailedModel>(`/api/content/admin/blocks/${blockId}/stories/${storyId}`);
    return data;
  },

  updateStory: async ({blockId, storyId, title, priority}: EditStoryParams): Promise<StoryModel> => {
    const {data} = await api.post<StoryModel>(`/api/content/admin/blocks/${blockId}/stories/${storyId}`, {
      title,
      priority,
    });
    return data;
  },

  deleteStory: async (blockId: string, storyId: string): Promise<void> => {
    await api.delete(`/api/content/admin/stories/${storyId}`);
  },

  publishStory: async (storyId: string): Promise<void> => {
    await api.post(`/api/content/admin/stories/${storyId}/published`);
  },

  unpublishStory: async (storyId: string): Promise<void> => {
    await api.delete(`/api/content/admin/stories/${storyId}/published`);
  },

  deleteStoryById: async (storyId: string): Promise<void> => {
    await api.delete(`/api/content/admin/stories/${storyId}`);
  },

  saveStoryScreens: async (storyId: string, screens: CreateStoryScreensDTO): Promise<void> => {
    await api.post(`/api/content/admin/stories/${storyId}/screens`, screens);
  },
};
